module.exports = __webpack_public_path__ + "img/202412_bnr900_900_1.4e2fa8f.png";